import React from 'react'
import cls from 'classnames'
import PropTypes from 'prop-types'

import { genId } from 'utils/generators'

import {
  ATTACK_ACTION_TYPES_CONST,
  UNVERIFIED_ACTION,
} from 'containers/Settings/Incidence/constants'

import CKEditor from 'components/elements/CKEditor'
import Select from 'components/lib/DesignSystem/Select'

class AttackActions extends React.Component {
  state = {
    selectedLang: null,
    messages: {},
    id: genId(4),
  }

  componentDidMount() {
    const { languages, messages } = this.props
    this.setDefaultLanguage(languages.find((elem) => elem.default)?.id)
    if (messages.length) this.setMessagesObj(messages)
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.languages !== this.props.languages &&
      this.props.languages.length &&
      !this.state.selectedLang
    ) {
      this.setDefaultLanguage(this.props.languages.find((elem) => elem.default)?.id)
    }
    if (prevProps.messages !== this.props.messages && this.props.messages.length) {
      this.setMessagesObj(this.props.messages)
    }
  }

  setDefaultLanguage = (id) => this.setState({ selectedLang: id })

  setMessagesObj = (messages) => {
    this.setState({
      messages: messages.reduce(
        (acc, elem) => ({
          ...acc,
          [elem.localeId]: { id: elem.localeId, text: elem.text },
        }),
        {}
      ),
    })
  }

  handleChange = (e) => this.props.setAction(e)

  handleLanguageChange = (value) => {
    const newLang = value || this.state.selectedLang
    if (newLang !== this.state.selectedLang) {
      this.setState({ selectedLang: newLang })
    }
  }

  handleEditorChange = (msg) => {
    const { selectedLang, messages } = this.state
    const newMessages = {
      ...messages,
      [selectedLang]: { ...messages[selectedLang], text: msg },
    }
    this.setState({ messages: newMessages })
    this.props.setMessages(selectedLang, msg)
  }

  render() {
    const { selectedLang, messages, id } = this.state
    const { action, value, languages, editorDisabled } = this.props

    return (
      <div className="attack-container">
        <div>
          <div className="action-text">
            {value === UNVERIFIED_ACTION ? (
              'When threshold is crossed by End-user or by Community take action'
            ) : (
              <span>
                When an incident is marked as
                <span className="sb"> Phishing</span>
              </span>
            )}
          </div>

          <Select
            className="db"
            placeholder="Select action"
            value={action}
            options={ATTACK_ACTION_TYPES_CONST}
            onSelect={this.handleChange}
            optionFilterProp="label"
            id={`${value}AutomatedIncidentResponseAction`}
          />

          <div className="action-text">Select message language</div>

          <Select
            className="db"
            placeholder="Select default language"
            value={messages[selectedLang]?.id}
            options={languages.map((l) => ({ value: l.id, label: l.name }))}
            onChange={this.handleLanguageChange}
            id={`${value}AutomatedIncidentResponseLanguage`}
            optionFilterProp="label"
          />
        </div>
        {action && (
          <div className={cls('right-side', action !== 3 && 'disabled')}>
            <CKEditor
              id={id}
              value={messages[selectedLang]?.text}
              onChange={this.handleEditorChange}
              disabled={editorDisabled}
              activeUpdateMode
            />
          </div>
        )}
      </div>
    )
  }
}

AttackActions.propTypes = {
  action: PropTypes.number,
  setAction: PropTypes.func.isRequired,
  setMessages: PropTypes.func.isRequired,
}

export default AttackActions
